var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"vue-notification-box",style:(_vm.style),on:{"mouseenter":function($event){return _vm.cancelHide()},"mouseleave":function($event){return _vm.hide()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }